import React from "react";

function CaretDown24(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M20.0306 9.53055L12.5306 17.0306C12.461 17.1003 12.3782 17.1556 12.2872 17.1933C12.1961 17.2311 12.0986 17.2505 12 17.2505C11.9014 17.2505 11.8038 17.2311 11.7128 17.1933C11.6217 17.1556 11.539 17.1003 11.4694 17.0306L3.96936 9.53055C3.82863 9.38982 3.74957 9.19895 3.74957 8.99993C3.74957 8.80091 3.82863 8.61003 3.96936 8.4693C4.1101 8.32857 4.30097 8.24951 4.49999 8.24951C4.69901 8.24951 4.88988 8.32857 5.03061 8.4693L12 15.4396L18.9694 8.4693C19.039 8.39962 19.1218 8.34435 19.2128 8.30663C19.3039 8.26892 19.4014 8.24951 19.5 8.24951C19.5985 8.24951 19.6961 8.26892 19.7872 8.30663C19.8782 8.34435 19.9609 8.39962 20.0306 8.4693C20.1003 8.53899 20.1556 8.62171 20.1933 8.71276C20.231 8.8038 20.2504 8.90138 20.2504 8.99993C20.2504 9.09847 20.231 9.19606 20.1933 9.2871C20.1556 9.37815 20.1003 9.46087 20.0306 9.53055Z"
        fill="#3A383F"
      />
    </svg>
  );
}

export default CaretDown24;
